import { useMemo } from 'react';

import { FinancialSettlementAdvancePayment } from '@dreryk/egabinet-financial-settlement-frontend-api';

import { calculateTotalPrice } from '../../totalPrice/totalPrice.utils';
import { calculateAdvancePaymentsAmount } from '../../form/advancePayment/advancePayment.utils';

type UseMedicalServicesPricesReturnFn = {
   totalPriceAmount: number;
   advancePaymentsAmount: number;
   amountDue: number;
};

type UseMedicalServicesPricesOptions = {
   medicalServicesPrices: number[];
   advancePayments?: FinancialSettlementAdvancePayment[];
};

export const useMedicalServicesPrices = (
   options: UseMedicalServicesPricesOptions
): UseMedicalServicesPricesReturnFn => {
   return useMemo(() => {
      const calculatedTotalPriceAmount = calculateTotalPrice(...options.medicalServicesPrices);
      const calculatedAdvancePaymentsAmount = calculateAdvancePaymentsAmount(options.advancePayments);
      const calculatedDueAmount = calculatedTotalPriceAmount - calculatedAdvancePaymentsAmount;

      return {
         totalPriceAmount: calculatedTotalPriceAmount,
         advancePaymentsAmount: calculatedAdvancePaymentsAmount,
         amountDue: calculatedDueAmount,
      };
   }, [options.medicalServicesPrices, options.advancePayments]);
};
